import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS attacks
 * @param {string} dirty - Unsanitized HTML string
 * @param {object} config - DOMPurify configuration options
 * @returns {string} Sanitized HTML string
 */
export const sanitize = (dirty, config = {}) => {
  if (!dirty || typeof dirty !== 'string') {
    return '';
  }

  const defaultConfig = {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'span', 'blockquote', 'pre', 'code'],
    ALLOWED_ATTR: ['href', 'title', 'target', 'class', 'id', 'style'],
    ALLOW_DATA_ATTR: false,
    ALLOW_UNKNOWN_PROTOCOLS: false
  };
  
  return DOMPurify.sanitize(dirty, { ...defaultConfig, ...config });
};

/**
 * Creates sanitized object for dangerouslySetInnerHTML
 * @param {string} html - HTML string to sanitize
 * @param {object} config - Optional DOMPurify configuration
 * @returns {object} Object with __html property for dangerouslySetInnerHTML
 */
export const createSanitizedHTML = (html, config) => ({
  __html: sanitize(html, config)
});
